// ============================================================================
// TEMAS DE CORES PARA CARDS
// ============================================================================

/**
 * Mapeamento de cores para cards - Paleta simplificada
 * 20 cores: 5 cores × 4 tons (da mais clara à mais escura)
 */
export const CARD_THEMES: Record<string, { headerBg: string; border: string; textColor: string }> = {
  // LINHA 1: BRANCO (tons de cinza)
  white: { headerBg: '#ffffff', border: '#d1d5db', textColor: '#000000' },
  'gray-10': { headerBg: '#f3f4f6', border: '#9ca3af', textColor: '#000000' },
  'gray-20': { headerBg: '#e5e7eb', border: '#6b7280', textColor: '#000000' },
  gray: { headerBg: '#9ca3af', border: '#4b5563', textColor: '#000000' },
  
  // LINHA 2: AMARELO
  'yellow-10': { headerBg: '#fefce8', border: '#facc15', textColor: '#000000' },
  'yellow-20': { headerBg: '#fef08a', border: '#eab308', textColor: '#000000' },
  yellow: { headerBg: '#eab308', border: '#a16207', textColor: '#000000' },
  'yellow-dark': { headerBg: '#ca8a04', border: '#854d0e', textColor: '#000000' },
  
  // LINHA 3: VERMELHO
  'red-10': { headerBg: '#fee2e2', border: '#f87171', textColor: '#000000' },
  'red-20': { headerBg: '#fecaca', border: '#ef4444', textColor: '#000000' },
  red: { headerBg: '#dc2626', border: '#991b1b', textColor: '#ffffff' },
  'red-dark': { headerBg: '#991b1b', border: '#7f1d1d', textColor: '#ffffff' },
  
  // LINHA 4: VERDE
  'green-10': { headerBg: '#dcfce7', border: '#86efac', textColor: '#000000' },
  'green-20': { headerBg: '#bbf7d0', border: '#4ade80', textColor: '#000000' },
  green: { headerBg: '#16a34a', border: '#15803d', textColor: '#ffffff' },
  'green-dark': { headerBg: '#15803d', border: '#14532d', textColor: '#ffffff' },
  
  // LINHA 5: AZUL
  'blue-10': { headerBg: '#dbeafe', border: '#93c5fd', textColor: '#000000' },
  'blue-20': { headerBg: '#bfdbfe', border: '#60a5fa', textColor: '#000000' },
  blue: { headerBg: '#2563eb', border: '#1d4ed8', textColor: '#ffffff' },
  'blue-dark': { headerBg: '#1e40af', border: '#1e3a8a', textColor: '#ffffff' },
};
